
    const path = window.location.pathname;
    const landing = document.getElementById('landing-root');
    const isMarketingPath = path === '/' || path === '/index.html';

    if (isMarketingPath) {
      import('/src/script.js');
    } else {
      if (landing) {
        landing.style.display = 'none';
      }
      window.scrollTo(0, 0);
      import('/src/main.jsx');
    }
  